import { type ModuleManifest } from '@/lib/modules/types'

/**
 * Decisioning admin module — `/decisioning*` on console.francisquini.ai.
 *
 * Dashboard 3.1 (Tier 3) — combines Phronesis (which decision chose what
 * for a user) with Moirai (which experiment/variant is live). One module
 * because the two systems always operate together: Phronesis emits
 * `decision_id`, Moirai resolves `variant_id` inside it. Spec:
 * `docs/cockpit/dashboards/tier-3-decision-quality.md` §3.1.5.
 *
 * Surface is `'admin'` — registered only on the console host. Each page
 * also wraps `<RequireAdmin>` for defence-in-depth.
 */
export const manifest: ModuleManifest = {
  module_id: 'decisioning',
  display_name: 'Decisioning',
  surface: 'admin',
  routes: [
    {
      path: '/decisioning',
      component: () =>
        import('@/modules/decisioning').then((m) => ({
          default: m.DecisioningHomePage,
        })),
      title: 'Decisioning — Dashboard',
      permissions: [],
    },
    {
      path: '/decisioning/decisions',
      component: () =>
        import('@/modules/decisioning').then((m) => ({
          default: m.DecisioningDecisionsPage,
        })),
      title: 'Decisioning — Decisões',
      permissions: [],
    },
    {
      path: '/decisioning/decisions/$id',
      component: () =>
        import('@/modules/decisioning').then((m) => ({
          default: m.DecisioningDecisionDetailPage,
        })),
      title: 'Decisioning — Detalhe da decisão',
      permissions: [],
    },
    {
      path: '/decisioning/experiments',
      component: () =>
        import('@/modules/decisioning').then((m) => ({
          default: m.DecisioningExperimentsPage,
        })),
      title: 'Decisioning — Experimentos',
      permissions: [],
    },
    {
      path: '/decisioning/experiments/$id',
      component: () =>
        import('@/modules/decisioning').then((m) => ({
          default: m.DecisioningExperimentDetailPage,
        })),
      title: 'Decisioning — Detalhe do experimento',
      permissions: [],
    },
    {
      path: '/decisioning/flags',
      component: () =>
        import('@/modules/decisioning').then((m) => ({
          default: m.DecisioningFlagsPage,
        })),
      title: 'Decisioning — Flags',
      permissions: [],
    },
    {
      path: '/decisioning/users/$userId/assignments',
      component: () =>
        import('@/modules/decisioning').then((m) => ({
          default: m.DecisioningUserAssignmentsPage,
        })),
      title: 'Decisioning — Assignments do usuário',
      permissions: [],
    },
  ],
}
